module.exports = __webpack_public_path__ + "static/img/passo2.35479543.svg";